import axios from 'axios'
import {
  SignUpResponse,
  LoginResponse,
  RegisterUserResponse,
  RegisterUserRequest,
  AuthenticationRequest,
  AuthenticationResponse,
  OnlineChangeDepartmentReturnUrlResponse,
  OnlineChangeDepartmentRequest,
  OnlineChangeDepartmentResponse,
  UserStatusResponse,
  ImageDataRegistrationResponse,
  CustomerResponse,
  CustomerRegistrationResponse,
  CustomerRegistrationRequest,
  CustomerRegistrationConfigResponse,
  AgreementApplyResponse,
  AgreementApplyRequest
} from '@/types/api'
import { Nullable } from '@/types/common'

const baseUrl = `${process.env.VUE_APP_API_URL_BASE}/online`

export default {
  // ユーザーサインアップAPI
  signUp (companyId: string): Promise<SignUpResponse> {
    return new Promise((resolve, reject) => {
      axios.get(`${baseUrl}/signUp`, { params: { companyId } })
        .then(({ data }: { data: SignUpResponse }) => {
          resolve(data)
        }).catch((errors) => {
          reject(errors)
        })
    })
  },

  // ユーザーログインAPI
  login (companyId: string): Promise<LoginResponse> {
    return new Promise((resolve, reject) => {
      axios.get(`${baseUrl}/login`, { params: { companyId } })
        .then(({ data }: { data: LoginResponse }) => {
          resolve(data)
        }).catch((errors) => {
          reject(errors)
        })
    })
  },

  // ユーザー登録API
  registerUser (params: RegisterUserRequest): Promise<RegisterUserResponse> {
    return new Promise((resolve, reject) => {
      axios.post(`${baseUrl}/registerUser`, params)
        .then(({ data }: { data: RegisterUserResponse }) => {
          resolve(data)
        }).catch((errors) => {
          reject(errors)
        })
    })
  },

  // ユーザー認証API
  authenticate (params: AuthenticationRequest): Promise<AuthenticationResponse> {
    return new Promise((resolve, reject) => {
      axios.post(`${baseUrl}/authenticate`, params)
        .then(({ data }: { data: AuthenticationResponse }) => {
          resolve(data)
        }).catch((errors) => {
          reject(errors)
        })
    })
  },

  // 部店変更遷移先取得API
  returnUrl (companyId: string, userId: string): Promise<OnlineChangeDepartmentReturnUrlResponse> {
    return new Promise((resolve, reject) => {
      axios.get(`${baseUrl}/changeDepartment/getReturnUrl`, { params: { companyId, userId } })
        .then(({ data }: { data: OnlineChangeDepartmentReturnUrlResponse }) => {
          resolve(data)
        }).catch((errors) => {
          reject(errors)
        })
    })
  },

  // 部店変更API
  changeDepartment (params: OnlineChangeDepartmentRequest): Promise<OnlineChangeDepartmentResponse> {
    return new Promise((resolve, reject) => {
      axios.post(`${baseUrl}/changeDepartment`, params)
        .then(({ data }: { data: OnlineChangeDepartmentResponse }) => {
          resolve(data)
        }).catch((errors) => {
          reject(errors)
        })
    })
  },

  // ユーザーの状態API
  status (companyId: string, userId: string): Promise<UserStatusResponse> {
    return new Promise((resolve, reject) => {
      axios.get(`${baseUrl}/status`, { params: { companyId, userId } })
        .then(({ data }: { data: UserStatusResponse }) => {
          resolve(data)
        }).catch((errors) => {
          reject(errors)
        })
    })
  },

  // オンライン本人確認書類のアップロードAPI
  imageDataRegistration (params: FormData): Promise<ImageDataRegistrationResponse> {
    return new Promise((resolve, reject) => {
      axios.post(`${baseUrl}/imageDataRegistration`, params)
        .then(({ data }: { data: ImageDataRegistrationResponse }) => {
          resolve(data)
        }).catch((errors) => {
          reject(errors)
        })
    })
  },

  // 口座開設申込情報の取得API
  customerInfo (userId: string): Promise<CustomerResponse> {
    return new Promise((resolve, reject) => {
      axios.get(`${baseUrl}/customerInfo/${userId}`)
        .then(({ data }: { data: CustomerResponse }) => {
          resolve(data)
        }).catch((errors) => {
          reject(errors)
        })
    })
  },

  // オンラインお客さま情報設定取得API
  customerRegistrationConfig (): Promise<CustomerRegistrationConfigResponse> {
    return new Promise((resolve, reject) => {
      axios.get(`${baseUrl}/customerRegistrationConfig`)
        .then(({ data }: { data: CustomerRegistrationConfigResponse }) => {
          resolve(data)
        }).catch((errors) => {
          reject(errors)
        })
    })
  },

  // オンラインお客さま情報登録API
  customerRegistration (params: Nullable<CustomerRegistrationRequest> & { selfCheck?: boolean }): Promise<CustomerRegistrationResponse> {
    return new Promise((resolve, reject) => {
      axios.post(`${baseUrl}/customerRegistration`, params)
        .then(({ data }: { data: CustomerRegistrationResponse }) => {
          resolve(data)
        }).catch((errors) => {
          reject(errors)
        })
    })
  },

  // オンライン口座開設申込への適用API
  apply (params: Partial<AgreementApplyRequest>): Promise<AgreementApplyResponse> {
    return new Promise((resolve, reject) => {
      axios.post(`${baseUrl}/apply`, params)
        .then(({ data }: { data: AgreementApplyResponse }) => {
          resolve(data)
        }).catch((errors) => {
          reject(errors)
        })
    })
  }
}
